
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/deep-clean",
      function () {
        return require("private-next-pages/services/deep-clean.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/deep-clean"])
      });
    }
  